var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6327 13.633H11.2621V9.92029C11.2621 9.03497 11.2462 7.89529 10.0291 7.89529C8.79431 7.89529 8.60537 8.85991 8.60537 9.85585V13.6327H6.23475V5.99797H8.51056V7.04135H8.54243C8.77019 6.65191 9.09931 6.33154 9.49474 6.11436C9.89017 5.89717 10.3371 5.79131 10.7879 5.80804C13.1907 5.80804 13.6337 7.38854 13.6337 9.44466L13.6327 13.633ZM3.55975 4.95441C2.79994 4.95454 2.18387 4.33866 2.18375 3.57885C2.18362 2.81904 2.79944 2.20298 3.55925 2.20285C4.31906 2.20266 4.93512 2.81854 4.93525 3.57835C4.93531 3.94323 4.79044 4.29319 4.53248 4.55125C4.27453 4.80931 3.92463 4.95433 3.55975 4.95441ZM4.74512 13.633H2.37194V5.99797H4.74506L4.74512 13.633ZM14.8146 0.00116449H1.18069C0.536312 -0.0060855 0.007875 0.510102 0 1.15448V14.8453C0.007625 15.49 0.536 16.0067 1.18062 15.9999H14.8146C15.4606 16.0079 15.9911 15.4912 16 14.8453V1.15341C15.9908 0.507789 15.4603 -0.0083355 14.8146 0.000101993",
    fill: "#063065"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/LinkedinIcon.0bd5c988087b595b3661c3f14d99c902.svg";
export { ForwardRef as ReactComponent };